function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import ReactDOM from 'react-dom';
import CustomControl from '../components/Map/Controls/CustomControl';
import mapboxgl from '!mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
var addMapGeocoderControl = function addMapGeocoderControl(map, props, geocoderHandlers, accessToken, countries) {
  var markerElement = document.createElement('div');
  markerElement.className = 'marker';
  markerElement.style.width = '10px';
  markerElement.style.height = '10px';
  markerElement.style.borderRadius = '10px';
  markerElement.style.backgroundColor = '#ff1c67';
  var geocoder = new MapboxGeocoder({
    accessToken: accessToken,
    mapboxgl: mapboxgl,
    countries: countries !== null && countries !== void 0 ? countries : '',
    limit: 20,
    zoom: 13,
    marker: {
      element: markerElement
    }
  });

  //add geocoder event handler listeners
  for (var key in geocoderHandlers) {
    geocoder.on(key, geocoderHandlers[key]);
  }
  map.addControl(geocoder);
  //hide the default mapbox geocoder control
  var geocoderControlContainer = document.querySelector('.mapboxgl-ctrl-geocoder');
  if (geocoderControlContainer) {
    geocoderControlContainer.style.display = 'none';
  }
};
export var addMapControls = function addMapControls(parent, map, accessToken, geocoderEnabled, geocoderHandlers, geocoderCountries, props, language) {
  var navControl = new mapboxgl.NavigationControl({
    showCompass: false
  });
  map.addControl(navControl, 'bottom-right');
  if (geocoderEnabled) {
    addMapGeocoderControl(map, props, geocoderHandlers, accessToken, geocoderCountries);
  }
  var geolocateControl = new mapboxgl.GeolocateControl({
    positionOptions: {
      enableHighAccuracy: true
    },
    trackUserLocation: true
  });
  map.addControl(geolocateControl, 'bottom-right');
  var homeControl = new CustomMapControl('home', parent, null, props, map, language);
  map.addControl(homeControl, 'bottom-right');
  var controls = {};
  ['top-left', 'top-right', 'bottom-left'].forEach(function (menuPosition) {
    var control = new CustomMapControl('menu', parent, "map-menu-container-" + menuPosition, props, map, language);
    controls[menuPosition] = control;
    map.addControl(control, menuPosition);
  });
};
export var removeMapCompasControl = function removeMapCompasControl(map, compassControl) {
  map.removeControl(compassControl);
};
export var addAttributionControl = function addAttributionControl(map) {
  map.addControl(new mapboxgl.AttributionControl({
    customAttribution: '<a href="https://vectuel.com/" target="_blank">&copy; Vectuel</a> '
  }));
};
export var addMapDrawControl = function addMapDrawControl(MapboxDraw, map, turf, primaryColor, lang, action) {
  var measurementLabels = [];
  var liveLabelMarker;
  var labelMarkers = [];
  var mapContainer = document.getElementById('map-container');
  var tooltipEl = document.createElement('div');
  tooltipEl.innerHTML = "" + (lang === 'fr' ? 'selectioner le point de départ' : 'select the starting point');
  tooltipEl.style.position = 'absolute';
  tooltipEl.style.border = '1px solid #ccc';
  tooltipEl.style.backgroundColor = '#333';
  tooltipEl.style.padding = '3px 6px';
  tooltipEl.style.margin = '15px';
  tooltipEl.style.fontSize = '12px';
  tooltipEl.style.color = '#fff';
  tooltipEl.style.opacity = '0.9';
  mapContainer.appendChild(tooltipEl);
  var draw = new MapboxDraw({
    displayControlsDefault: false,
    controls: {
      line_string: true,
      polygon: true,
      trash: true
    },
    userProperties: true,
    styles: [
    // default themes provided by MB Draw
    {
      id: 'gl-draw-polygon-fill-inactive',
      type: 'fill',
      filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
      paint: {
        'fill-color': '#439aac',
        'fill-outline-color': '#439aac',
        'fill-opacity': 0.1
      }
    }, {
      id: 'gl-draw-polygon-fill-active',
      type: 'fill',
      filter: ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
      paint: {
        'fill-color': primaryColor,
        'fill-outline-color': primaryColor,
        'fill-opacity': 0.1
      }
    }, {
      id: 'gl-draw-polygon-midpoint',
      type: 'circle',
      filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'midpoint']],
      paint: {
        'circle-radius': 3,
        'circle-color': primaryColor
      }
    }, {
      id: 'gl-draw-polygon-stroke-inactive',
      type: 'line',
      filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': '#439aac',
        'line-width': 2
      }
    }, {
      id: 'gl-draw-polygon-stroke-active',
      type: 'line',
      filter: ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': primaryColor,
        'line-dasharray': [0.2, 2],
        'line-width': 2
      }
    }, {
      id: 'gl-draw-line-inactive',
      type: 'line',
      filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'LineString'], ['!=', 'mode', 'static']],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': '#439aac',
        'line-width': 2
      }
    }, {
      id: 'gl-draw-line-active',
      type: 'line',
      filter: ['all', ['==', '$type', 'LineString'], ['==', 'active', 'true']],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': primaryColor,
        'line-width': 2
      }
    }, {
      id: 'gl-draw-polygon-and-line-vertex-stroke-inactive',
      type: 'circle',
      filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point'], ['!=', 'mode', 'static']],
      paint: {
        'circle-radius': 5,
        'circle-color': '#fff'
      }
    }, {
      id: 'gl-draw-polygon-and-line-vertex-inactive',
      type: 'circle',
      filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point'], ['!=', 'mode', 'static']],
      paint: {
        'circle-radius': 3,
        'circle-color': primaryColor
      }
    }, {
      id: 'gl-draw-point-point-stroke-inactive',
      type: 'circle',
      filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'Point'], ['==', 'meta', 'feature'], ['!=', 'mode', 'static']],
      paint: {
        'circle-radius': 5,
        'circle-opacity': 1,
        'circle-color': '#fff'
      }
    }, {
      id: 'gl-draw-point-inactive',
      type: 'circle',
      filter: ['all', ['==', 'active', 'false'], ['==', '$type', 'Point'], ['==', 'meta', 'feature'], ['!=', 'mode', 'static']],
      paint: {
        'circle-radius': 3,
        'circle-color': '#439aac'
      }
    }, {
      id: 'gl-draw-point-stroke-active',
      type: 'circle',
      filter: ['all', ['==', '$type', 'Point'], ['==', 'active', 'true'], ['!=', 'meta', 'midpoint']],
      paint: {
        'circle-radius': 7,
        'circle-color': '#fff'
      }
    }, {
      id: 'gl-draw-point-active',
      type: 'circle',
      filter: ['all', ['==', '$type', 'Point'], ['!=', 'meta', 'midpoint'], ['==', 'active', 'true']],
      paint: {
        'circle-radius': 5,
        'circle-color': primaryColor
      }
    }, {
      id: 'gl-draw-polygon-fill-static',
      type: 'fill',
      filter: ['all', ['==', 'mode', 'static'], ['==', '$type', 'Polygon']],
      paint: {
        'fill-color': '#404040',
        'fill-outline-color': '#404040',
        'fill-opacity': 0.1
      }
    }, {
      id: 'gl-draw-polygon-stroke-static',
      type: 'line',
      filter: ['all', ['==', 'mode', 'static'], ['==', '$type', 'Polygon']],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': '#404040',
        'line-width': 2
      }
    }, {
      id: 'gl-draw-line-static',
      type: 'line',
      filter: ['all', ['==', 'mode', 'static'], ['==', '$type', 'LineString']],
      layout: {
        'line-cap': 'round',
        'line-join': 'round'
      },
      paint: {
        'line-color': '#404040',
        'line-width': 2
      }
    }, {
      id: 'gl-draw-point-static',
      type: 'circle',
      filter: ['all', ['==', 'mode', 'static'], ['==', '$type', 'Point']],
      paint: {
        'circle-radius': 5,
        'circle-color': '#404040'
      }
    },
    // new styles for toggling colors
    {
      id: 'gl-draw-polygon-color-picker',
      type: 'fill',
      filter: ['all', ['==', '$type', 'Polygon'], ['has', 'user_portColor']],
      paint: {
        'fill-color': ['get', 'user_portColor'],
        'fill-outline-color': ['get', 'user_portColor'],
        'fill-opacity': 0.5
      }
    }, {
      id: 'gl-draw-line-color-picker',
      type: 'line',
      filter: ['all', ['==', '$type', 'LineString'], ['has', 'user_portColor']],
      paint: {
        'line-color': ['get', 'user_portColor'],
        'line-width': 2
      }
    }, {
      id: 'gl-draw-point-color-picker',
      type: 'circle',
      filter: ['all', ['==', '$type', 'Point'], ['has', 'user_portColor']],
      paint: {
        'circle-radius': 3,
        'circle-color': ['get', 'user_portColor']
      }
    }]
  });
  map.addControl(draw, 'bottom-right');
  map.on('load', function () {
    var el = document.createElement('div');
    el.className = 'marker-label';
    var span = document.createElement('span');
    span.className = 'span';
    span.setAttribute('id', 'midpointLabel');
    el.appendChild(span);
    liveLabelMarker = new mapboxgl.Marker(el);
    map.on('click', function (event) {
      if (draw.getMode() === 'draw_polygon' || draw.getMode() === 'draw_line_string') {
        tooltipEl.style.display = 'none';
        measurementLabels.push(event.lngLat);
        if (measurementLabels.length > 1) {
          var _measurementLabels = measurementLabels[measurementLabels.length - 2],
            lat = _measurementLabels.lat,
            lng = _measurementLabels.lng;
          var midpoint = turf.midpoint([lng, lat], [event.lngLat.lng, event.lngLat.lat]);
          var lineDist = turf.distance([lng, lat], [event.lngLat.lng, event.lngLat.lat]);
          el = document.createElement('div');
          el.className = 'marker-label';
          span = document.createElement('span');
          span.className = 'span';
          span.innerHTML = lineDist.toFixed(2) + " km";
          el.appendChild(span);
          var markers = new mapboxgl.Marker(el).setLngLat(midpoint.geometry.coordinates).addTo(map);
          labelMarkers.push(markers);
        }
      } else {
        measurementLabels = [];
      }
    });
    map.on('mousemove', function (event) {
      if (measurementLabels.length > 0) {
        var _measurementLabels2 = measurementLabels[measurementLabels.length - 1],
          lat = _measurementLabels2.lat,
          lng = _measurementLabels2.lng;
        var midpoint = turf.midpoint([lng, lat], [event.lngLat.lng, event.lngLat.lat]);
        if (liveLabelMarker) {
          liveLabelMarker.setLngLat(midpoint.geometry.coordinates);
          liveLabelMarker.addTo(map);
          var lineDist = turf.distance([lng, lat], [event.lngLat.lng, event.lngLat.lat]);
          var midpointLabel = document.getElementById('midpointLabel');
          midpointLabel.innerHTML = lineDist.toFixed(2) + " km";
        }
      } else {
        tooltipEl.style.display = 'none';
        if (draw.getMode() === 'draw_polygon' || draw.getMode() === 'draw_line_string') {
          tooltipEl.style.display = 'block';
          tooltipEl.style.left = event.point.x < 0 ? 0 : event.point.x + 'px';
          tooltipEl.style.top = event.point.y < 0 ? 0 : event.point.y + 'px';
        }
      }
    });
  });
  map.on('draw.create', function (e) {
    updateArea(e);
  });
  map.on('draw.delete', function () {
    setTimeout(function () {
      for (var _i = 0, _labelMarkers = labelMarkers; _i < _labelMarkers.length; _i++) {
        var marker = _labelMarkers[_i];
        marker.remove();
      }
      draw.trash();
      action({});
    }, 0);
  });
  map.on('draw.selectionchange', function (e) {
    if (e.features.length && e.features[0].type === 'Feature') {
      var feat = e.features[0];
      var data = draw.get(feat.id);
      var area = turf.area(data);
      var rounded_area = Math.round(area * 100) / 100 / 1000000;
      var distance = turf.length(data);
      action({
        area: !Number.isInteger(rounded_area) ? rounded_area.toFixed(2) : rounded_area,
        distance: distance.toLocaleString(),
        mode: e.features[0].geometry.type
      });
    }
  });
  function updateArea(e) {
    liveLabelMarker.remove();
    var data = draw.getAll();
    var area = turf.area(data);
    var rounded_area = Math.round(area * 100) / 100 / 1000000;
    var distance = turf.length(data);
    if (draw.getMode() === 'draw_polygon') {
      polygonMarkers();
    }
    action({
      area: !Number.isInteger(rounded_area) ? rounded_area.toFixed(2) : rounded_area,
      distance: distance.toLocaleString(),
      mode: e.features[0].geometry.type
    });
  }
  function polygonMarkers() {
    var features = draw.getAll().features.filter(function (_) {
      return _.geometry.type === 'Polygon';
    });
    features.forEach(function (feature) {
      for (var key = 0; key < feature.geometry.coordinates[0].length; key++) {
        var item = feature.geometry.coordinates[0][key];
        if (!feature.geometry.coordinates[0][key + 1]) {
          continue;
        }
        var midpoint = turf.midpoint(item, feature.geometry.coordinates[0][key + 1]);
        var lineDist = turf.distance(item, feature.geometry.coordinates[0][key + 1]);
        var el = document.createElement('div');
        el.className = 'marker-label';
        var span = document.createElement('span');
        span.className = 'span';
        span.innerHTML = lineDist.toFixed(2) + " km";
        el.appendChild(span);
        var markers = new mapboxgl.Marker(el).setLngLat(midpoint.geometry.coordinates).addTo(map);
        labelMarkers.push(markers);
      }
    });
  }
};
export var addMapCompasControl = function addMapCompasControl(parent, props, map) {
  var compassControl = new CustomMapControl('compass', parent, null, props, map);
  map.addControl(compassControl, 'bottom-right');
  return compassControl;
};
var CustomMapControl = /*#__PURE__*/function () {
  function CustomMapControl(type, parent, className, initialOptions, map, lang) {
    this.type = type;
    this.parent = parent;
    this.container = null;
    this.className = className;
    this.initialOptions = initialOptions;
    this.map = map;
    this.lang = lang;
  }
  var _proto = CustomMapControl.prototype;
  _proto._newDefaultComponent = function _newDefaultComponent() {
    return /*#__PURE__*/React.createElement(CustomControl, {
      type: this.type,
      map: this.map,
      initialOptions: this.initialOptions,
      language: this.lang
    });
  };
  _proto.onAdd = function onAdd(map) {
    this.map = map;
    this.container = document.createElement('div');
    var classNames = ['mapboxgl-ctrl', 'custom-map-control'];
    if (this.type === 'menu') {
      classNames.push('map-menu-container');
    } else if (this.type === 'main-menu') {
      classNames.push('main-layers-menu-container');
    }
    if (this.className) {
      classNames.push(this.className);
    }
    this.container.className = classNames.join(' ');
    var component = this.type === 'menu' || this.type === 'main-menu' ? null : this._newDefaultComponent();
    if (component) {
      try {
        ReactDOM.render(component, this.container);
      } catch (e) {
        console.log(e);
      }
    }
    return this.container;
  };
  _proto.onRemove = function onRemove() {
    if (this.container) {
      this.container.parentNode.removeChild(this.container);
    }
    this.map = undefined;
  };
  _createClass(CustomMapControl, [{
    key: "attached",
    get: function get() {
      return !!this.map;
    }
  }]);
  return CustomMapControl;
}();